"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextWrapper = exports.DescriptionWrapper = exports.TitleWrapper = exports.ImgWrapper = exports.Wrapper = exports.IconWrapper = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const colors_1 = require("../../../theme/colors");
exports.IconWrapper = styled_components_1.default.div `
  position: absolute;
  right: 10px;
  width: 20px;
  height: 20px;
  top: 8px;
  padding: 2px;
  display: none;
  justify-content: center;
  align-items: center;

  a {
    display: flex;
  }

  :hover {
    background: ${colors_1.BLACK};
  }
`;
exports.Wrapper = styled_components_1.default.div `
  display: flex;
  padding: 10px 40px 10px 10px;
  padding-right: 40px;
  position: relative;
  border: 1px solid transparent;
  cursor: pointer;

  &:hover {
    border: 1px solid ${colors_1.BLACK};

    ${exports.IconWrapper} {
      display: flex;
    }
  }
`;
exports.ImgWrapper = styled_components_1.default.div `
  display: flex;
  min-width: 70px;
  max-width: 80px;
  margin-right: 10px;
  max-height: 80px;

  @media (max-width: 687px) {
    ${({ $titleOnly }) => $titleOnly &&
    (0, styled_components_1.css) `
        display: none;
      `}
  }

  img {
    max-width: 100%;
  }
`;
exports.TitleWrapper = styled_components_1.default.div `
  display: flex;
  font-weight: bold;
  font-size: 14px;
  margin-top: 5px;
  word-wrap: break-word;
  word-break: break-word;
`;
exports.DescriptionWrapper = styled_components_1.default.div `
  display: flex;
  font-size: 13px;
  margin-top: 5px;
  color: ${colors_1.BLACK};

  @media (max-width: 687px) {
    ${(props) => props.$titleOnly &&
    (0, styled_components_1.css) `
        display: none;
      `}
  }
`;
exports.TextWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
`;
//# sourceMappingURL=SwitchMenuItem.styles.js.map